import { useEffect, useState } from 'react'
import { toastStore, type ToastNotification } from '../notifications/toast-store'

export function useToastNotifications() {
  const [toasts, setToasts] = useState<ToastNotification[]>([])

  useEffect(() => {
    return toastStore.subscribe(setToasts)
  }, [])

  const dismiss = (id: string) => toastStore.dismiss(id)

  return { toasts, dismiss }
}
